export const DASHBOARD_STATISTIC_FETCH = 'employer/DASHBOARD_STATISTIC_FETCH';
export const DASHBOARD_STATISTIC_SUCCESS = 'employer/DASHBOARD_STATISTIC_SUCCESS';

export const DASHBOARD_EMPLOYEE_ATTENDANCE_FETCH = 'employer/DASHBOARD_EMPLOYEE_ATTENDANCE_FETCH';
export const DASHBOARD_EMPLOYEE_ATTENDANCE_SUCCESS = 'employer/DASHBOARD_EMPLOYEE_ATTENDANCE_SUCCESS';

export const DASHBOARD_DOWNLOAD_ATTENDANCE_FETCH = 'employer/DASHBOARD_DOWNLOAD_ATTENDANCE_FETCH';
export const DASHBOARD_DOWNLOAD_ATTENDANCE_SUCCESS = 'employer/DASHBOARD_DOWNLOAD_ATTENDANCE_SUCCESS';
export const DASHBOARD_DOWNLOAD_ATTENDANCE_ERROR = 'employer/DASHBOARD_DOWNLOAD_ATTENDANCE_ERROR';
